import React from "react";
import { stepStyles } from "./formStyles";

export const Names = ({ formData, setForm, navigation }) => {
  const { firstName, lastName } = formData;

  return (
    <div className={stepStyles.page}>
      <div className={stepStyles.content}>
        <div className={stepStyles.panel}>
          <h1 className={stepStyles.title}>What is your name?</h1>
          <div className={stepStyles.fieldStack}>
            <div className={stepStyles.fieldRow}>
              <div className="w-full md:w-auto">
                <input
                  name="firstName"
                  value={firstName}
                  onChange={setForm}
                  id="firstName"
                  className={stepStyles.input}
                  placeholder="John"
                />
              </div>
              <label htmlFor="firstName" className={stepStyles.fieldLabel}>
                First Name
              </label>
            </div>
            <div className={stepStyles.fieldRow}>
              <div className="w-full md:w-auto">
                <input
                  name="lastName"
                  value={lastName}
                  onChange={setForm}
                  id="lastName"
                  className={stepStyles.input}
                  placeholder="Doe"
                />
              </div>
              <label htmlFor="lastName" className={stepStyles.fieldLabel}>
                Last Name
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <button className={`${stepStyles.buttonAlt} w-full md:w-auto`} onClick={() => navigation.previous()}>
            Back
          </button>
          <button className={`${stepStyles.button} w-full md:w-auto`} onClick={() => navigation.next()}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};
